import React from 'react';

function PaypalReceipt({ receipt, golfclub }) {
  return (
    <div className="payment-container">
      <div id="payment-view" className="px-5 py-4" style={{ border: '1px solid #ccc', borderRadius: '5px' }}>
        <div className="row">
          <div className="col" style={{ minHeight: 400 }}>
            <p className="text-left">
              <strong>Vielen Dank für Ihre Bestellung bei uns im {golfclub}!</strong>
              <br />
              <br /> Ihre Bestellung ist bei uns eingegangen und wird nun bearbeitet.
              <br /> <strong>Bestellnummer:</strong> {receipt.purchase_units[0].reference_id}
              <br />
              <strong>Gesamtbetrag:</strong> {receipt.purchase_units[0].amount.value}{' '}
              {receipt.purchase_units[0].amount.currency_code}
              <br />
              <br />
              Eine Quittung wurde an die beim Kauf angegebene E-Mail-Adresse ({receipt.payer.email_address}) gesendet.
              <br />
              <br />
              Bei Fragen zu Ihrer Bestellung kontaktieren Sie uns im {golfclub}.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaypalReceipt;
